import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Plyr from "plyr";

import "reset-css";
import "plyr/dist/plyr.css";
import "../styles/index.scss";

gsap.registerPlugin(ScrollTrigger);
// gsap.ticker.fps(24);
if (process.env.NODE_ENV === "development") {
    require("../index.html");
}
function lerp(min, max, t) {
    return min * (1 - t) + max * t;
}
function inverseLerp(min, max, val) {
    return (val - min) / (max - min);
}

var inlineSVG = require("inline-svg");

const controlsMuteButton = `
    <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
            
        <svg class="icon--pressed" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="white"/>
        <path d="M35.6004 33.2998V21.5998C35.6004 19.7998 34.6004 19.3998 33.3004 20.6998L28.3004 25.6998H27.9004L35.6004 33.2998Z" fill="black"/>
        <path d="M22.9004 25.8994C22.6004 26.0994 22.4004 26.4994 22.4004 26.8994V32.9994C22.4004 33.6994 22.9004 34.1994 23.6004 34.1994H28.3004L33.3004 39.1994C34.5004 40.3994 35.4004 39.9994 35.5004 38.4994L22.9004 25.8994Z" fill="black"/>
        <path d="M40.0004 41.1998C39.8004 41.1998 39.6004 41.0998 39.4004 40.9998L20.5004 21.9998C20.2004 21.6998 20.2004 21.1998 20.5004 20.8998C20.8004 20.5998 21.3004 20.5998 21.6004 20.8998L40.5004 39.7998C40.8004 40.0998 40.8004 40.5998 40.5004 40.8998C40.4004 41.0998 40.2004 41.1998 40.0004 41.1998Z" fill="black"/>
        </svg>
        <svg class="icon--not-pressed" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="white"/>
        <path d="M33.3004 20.6995L28.3004 25.6995H23.6004C22.9004 25.6995 22.4004 26.1995 22.4004 26.8995V32.9995C22.4004 33.6995 22.9004 34.1995 23.6004 34.1995H28.3004L33.3004 39.1995C34.5004 40.3995 35.6004 39.9995 35.6004 38.2995V21.5995C35.6004 19.8995 34.6004 19.4995 33.3004 20.6995Z" fill="black"/>
        </svg>

        <!--<span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>-->
    </button>`;

const controlsPlayModalButton = `
    <button type="button" class="plyr__control plyr__control--play" aria-label="Play">

        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="white"/>
        <path d="M23 40.3996V19.5996L41 29.9996L23 40.3996Z" fill="black"/>
        </svg>

        <!--<span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>-->
    </button>`;

const optionsHero = {
    fullscreen: {
        enabled: false,
        iosNative: false,
    },
    vimeo: {
        dnt: true,
    },
    loop: { active: true },
    controls: false,
    muted: true,
    autoplay: true,
    storage: { enabled: false },
};
const options = {
    fullscreen: {
        enabled: false,
        iosNative: false,
    },
    controls: controlsMuteButton,
    muted: true,
    vimeo: {
        dnt: true,
    },
    autoplay: true,
    loop: { active: true },
    storage: { enabled: false },
};
const optionsPlayButton = {
    fullscreen: {
        enabled: false,
        iosNative: false,
    },
    controls: controlsPlayModalButton,
    muted: true,
    vimeo: {
        dnt: true,
    },
    autoplay: true,
    loop: { active: true },
    storage: { enabled: false },
};
const optionsMobile = {
    fullscreen: {
        enabled: false,
        iosNative: false,
    },
    controls: controlsMuteButton,
    ratio: "5:4",
    muted: true,
    vimeo: {
        dnt: true,
    },
    loop: { active: true },
    autoplay: true,
    storage: { enabled: false },
};
const optionsMobilePlayButton = {
    fullscreen: {
        enabled: false,
        iosNative: false,
    },
    controls: controlsPlayModalButton,
    ratio: "5:4",
    muted: true,
    vimeo: {
        dnt: true,
    },
    loop: { active: true },
    autoplay: true,
    storage: { enabled: false },
};

const playerHero = new Plyr(
    document.querySelector(".embeded-video"),
    optionsHero
);
playerHero.play();
playerHero.on("ready", function () {
    var player1 = new Plyr(document.querySelector("#player-1"), options);
    var player2 = new Plyr(document.querySelector("#player-2"), options);
    var player3 = new Plyr(document.querySelector("#player-3"), options);
    var player4 = new Plyr(document.querySelector("#player-4"), options);
    var player5 = new Plyr(
        document.querySelector("#player-5"),
        optionsPlayButton
    );

    var player1Mobile = new Plyr(
        document.querySelector("#player-1-mobile"),
        optionsMobile
    );
    var player2Mobile = new Plyr(
        document.querySelector("#player-2-mobile"),
        optionsMobile
    );
    var player3Mobile = new Plyr(
        document.querySelector("#player-3-mobile"),
        optionsMobile
    );
    var player4Mobile = new Plyr(
        document.querySelector("#player-4-mobile"),
        optionsMobile
    );
    var player5Mobile = new Plyr(
        document.querySelector("#player-5-mobile"),
        optionsMobilePlayButton
    );


var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-1",
            // scroller: ".smooth-scroll",
            start: "top 70%",
            end: "bottom bottom",
            // scrub: true
        },
    })
    .from(".content-1-1", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-2",
            start: "top 70%",
            end: "bottom bottom",
            // scrub: true,
        },
    })
    .from(".content-2-1 h2", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".content-2-1 p", 1.2, { y: "100", autoAlpha: 0 }, 0.3);
var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-3",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-3-1", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".video-1", 1.2, { y: "100", autoAlpha: 0 }, 0.3);
var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-4",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-4-1 h2", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".content-4-1 p", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-5",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-5-1", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".video-2", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-6",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-6-1", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".video-3", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-7",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-7-1", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".video-4", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-8",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-8-1 h2", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".content-8-1 p", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

var tlContent = gsap
    .timeline({
        scrollTrigger: {
            trigger: ".section--content-9",
            // scrub: true,
            start: "top 70%",
            end: "bottom bottom",
        },
    })
    .from(".content-9-1 h2", 1.2, { y: "100", autoAlpha: 0 }, 0.3)
    .from(".content-9-1 p", 1.2, { y: "100", autoAlpha: 0 }, 0.3);

// ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
// ScrollTrigger.refresh();
// Create a condition that targets viewports at least 1024px wide
const mediaQuery = window.matchMedia("(min-width: 1024px)");
function handleTabletChange(e) {
    // Check if the media query is true
    if (e.matches) {
        renderDesktop();
    } else {
        renderMobile();
    }
}
// Register event listener
mediaQuery.addListener(handleTabletChange);
// Initial check
handleTabletChange(mediaQuery);

function renderDesktop() {
    inlineSVG.init(
        {
            svgSelector: ".svg-desktop", // the class attached to all images that should be inlined
            initClass: "js-inlinesvg", // class added to <html>
        },
        function () {
            function calculateDraw(progress) {
                let index = SCROLL_MAP.findIndex(
                    ({ scroll }) => Math.min(1, Math.max(0, progress)) < scroll
                );
                let fromBucket = SCROLL_MAP[index - 1];
                let toBucket = SCROLL_MAP[index];
                let relativeScrollInBucket = inverseLerp(
                    fromBucket.scroll,
                    toBucket.scroll,
                    progress
                );

                let size = lerp(
                    fromBucket.size,
                    toBucket.size,
                    relativeScrollInBucket
                );
                let offset = lerp(
                    fromBucket.offset,
                    toBucket.offset,
                    relativeScrollInBucket
                );
                // console.log(
                //     progress.toFixed(4),
                //     offset.toFixed(4),
                //     size.toFixed(4),
                //     (offset + size).toFixed(2)
                // );
                // let width = lerp(fromBucket.width, toBucket.width, relativeScrollInBucket);

                let pathLength = document
                    .querySelector("#svg-front")
                    .getTotalLength();

                gsap.to(
                    "#svg-front",
                    0,
                    { strokeDashoffset: -pathLength + offset },
                    0
                );
                gsap.to(
                    "#svg-front",
                    0,
                    { strokeDasharray: `${size}, 100000` },
                    0
                );
                gsap.to(
                    "#svg-back",
                    0,
                    { strokeDashoffset: -pathLength + offset },
                    0
                );
                gsap.to(
                    "#svg-back",
                    0,
                    { strokeDasharray: `${offset}, 100000` },
                    0
                );
                gsap.to(
                    "#svg-dot",
                    0,
                    { strokeDashoffset: `-${pathLength - offset}` },
                    0
                );
            }

            let pathLength = document
                .querySelector("#svg-front")
                .getTotalLength();

            const SCROLL_MAP = [
                { scroll: 0, size: 100, offset: 0, width: 3 },
                { scroll: 0.03, size: 300, offset: 300, width: 3 },
                { scroll: 0.04, size: 300, offset: 500, width: 3 },
                // 1. Illustration
                { scroll: 0.05, size: 4200, offset: 5000, width: 3 },
                { scroll: 0.06, size: 7500, offset: 8500, width: 3 },
                { scroll: 0.07, size: 8000, offset: 9000, width: 3 },

                { scroll: 0.071, size: 6000, offset: 9100, width: 3 },
                { scroll: 0.072, size: 4000, offset: 9200, width: 3 },
                { scroll: 0.073, size: 2000, offset: 9300, width: 3 },

                { scroll: 0.075, size: 300, offset: 9500, width: 3 },

                // 2. Illustration
                { scroll: 0.077, size: 300, offset: 10000, width: 3 },
                { scroll: 0.13, size: 10900, offset: 21000, width: 3 },
                { scroll: 0.17, size: 10900, offset: 22000, width: 3 },

                { scroll: 0.18, size: 300, offset: 22500, width: 3 },
                { scroll: 0.21, size: 300, offset: 23000, width: 3 },

                // 3. Illustration
                { scroll: 0.24, size: 300, offset: 23500, width: 3 },
                { scroll: 0.27, size: 500, offset: 24500, width: 3 },
                { scroll: 0.28, size: 900, offset: 25000, width: 3 },
                { scroll: 0.295, size: 5800, offset: 30000, width: 3 },
                { scroll: 0.3, size: 6000, offset: 30250, width: 3 },
                { scroll: 0.31, size: 6050, offset: 30500, width: 3 },

                { scroll: 0.32, size: 300, offset: 30550, width: 3 },
                { scroll: 0.4, size: 300, offset: 32000, width: 3 },

                // 4. Illustration
                { scroll: 0.41, size: 1000, offset: 33000, width: 3 },
                { scroll: 0.42, size: 2400, offset: 34500, width: 3 },
                { scroll: 0.45, size: 7850, offset: 40000, width: 3 },
                { scroll: 0.46, size: 10800, offset: 43000, width: 3 },
                { scroll: 0.465, size: 11750, offset: 44000, width: 3 },
                { scroll: 0.48, size: 12200, offset: 44500, width: 3 },

                { scroll: 0.5, size: 300, offset: 45000, width: 3 },
                { scroll: 0.57, size: 300, offset: 46000, width: 3 },

                // 5. Illustration
                { scroll: 0.58, size: 1000, offset: 47000, width: 3 },
                { scroll: 0.64, size: 13650, offset: 59700, width: 3 },
                { scroll: 0.66, size: 14950, offset: 61000, width: 3 },

                { scroll: 0.69, size: 300, offset: 61750, width: 3 },
                { scroll: 0.73, size: 300, offset: 62000, width: 3 },
                { scroll: 0.74, size: 300, offset: 62250, width: 3 },
                { scroll: 0.75, size: 500, offset: 63000, width: 3 },

                // 6. Illustration
                { scroll: 0.795, size: 11500, offset: 74375, width: 3 },
                { scroll: 0.8, size: 11550, offset: 74500, width: 3 },

                { scroll: 0.81, size: 300, offset: 75000, width: 3 },
                { scroll: 0.84, size: 300, offset: 75500, width: 3 },

                // 7. Illustration
                { scroll: 0.86, size: 7500, offset: 83000, width: 3 },
                { scroll: 0.895, size: 8000, offset: 83500, width: 3 },
                { scroll: 0.9, size: 10500, offset: 86500, width: 3 },

                { scroll: 0.92, size: 300, offset: 87000, width: 3 },
                { scroll: 0.925, size: 300, offset: 87500, width: 3 },

                // 8. Illustration
                { scroll: 0.93, size: 6000, offset: 93500, width: 3 },
                {
                    scroll: 0.98,
                    size: 9000,
                    offset: pathLength - 500,
                    width: 3,
                },
                { scroll: 0.99, size: 300, offset: pathLength - 400, width: 3 },
                {
                    scroll: 0.995,
                    size: 300,
                    offset: pathLength - 200,
                    width: 3,
                },

                // End
                {
                    scroll: 1 + Number.EPSILON,
                    size: 10,
                    offset: pathLength - 10,
                    width: 3,
                },
            ];

            gsap.set("#svg-front", { strokeDashoffset: -pathLength });
            gsap.set("#svg-front", { strokeDasharray: `0, 100000` });
            gsap.set("#svg-back", { strokeDashoffset: -pathLength });
            gsap.set("#svg-back", { strokeDasharray: `0, 100000` });
            gsap.set("#svg-dot", { strokeDashoffset: -pathLength });

            gsap.set(
                [
                    "#illustration-1-1",
                    "#illustration-1-2",
                    "#illustration-1-3",
                    "#illustration-1-4",
                    "#illustration-1-5",
                    "#illustration-1-6",
                ],
                { transformOrigin: "center center" }
            );
            var tlIllustration1 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-1",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom 70%",
                        scrub: true,
                    },
                })
                .from("#illustration-1-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-1-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-3", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-4", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-5", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-6", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                [
                    "#illustration-2-1",
                    "#illustration-2-2",
                    "#illustration-2-3",
                    "#illustration-2-4",
                ],
                { transformOrigin: "center center" }
            );
            var tlIllustration2 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-2",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-2-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-2-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-2-3", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-2-4", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                [
                    "#illustration-3-1",
                    "#illustration-3-2",
                    "#illustration-3-3",
                    "#illustration-3-4",
                    "#illustration-3-5",
                    "#illustration-3-6",
                    "#illustration-3-7",
                ],
                { transformOrigin: "center center" }
            );
            var tlIllustration3 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-3",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-3-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-3-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-3", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-4", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-5", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-6", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-7", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-4-1", "#illustration-4-2", "#illustration-4-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration4 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-4",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-4-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-4-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-4-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-5-1", "#illustration-5-2", "#illustration-5-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration5 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-5",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-5-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-5-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-5-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-6-1", "#illustration-6-2", "#illustration-6-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration6 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-6",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-6-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-6-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-6-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-7-1", "#illustration-7-2", "#illustration-7-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration7 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-7",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-7-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-7-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-7-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-8-1", "#illustration-8-2", "#illustration-8-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration8 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-8",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-8-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-8-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-8-3", { scale: 0, autoAlpha: 0 }, "+=0.1");
            var tlVideo1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-3",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        // playerHero.pause();
                        player1.play();
                    },
                    onEnterBack: (self) => {
                        player1.play();
                    },
                    onLeave: (self) => {
                        player1.pause();
                    },
                    onLeaveBack: (self) => {
                        player1.pause();
                    },
                },
            });
            var tlVideo2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-5",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        player2.play();
                    },
                    onEnterBack: (self) => {
                        player2.play();
                    },
                    onLeave: (self) => {
                        player2.pause();
                    },
                    onLeaveBack: (self) => {
                        player2.pause();
                    },
                },
            });
            var tlVideo3 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-6",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        player3.play();
                    },
                    onEnterBack: (self) => {
                        player3.play();
                    },
                    onLeave: (self) => {
                        player3.pause();
                    },
                    onLeaveBack: (self) => {
                        player3.pause();
                    },
                },
            });
            var tlVideo4 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-7",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        player4.play();
                    },
                    onEnterBack: (self) => {
                        player4.play();
                    },
                    onLeave: (self) => {
                        player4.pause();
                    },
                    onLeaveBack: (self) => {
                        player4.pause();
                    },
                },
            });

            // var tlVideo5 = gsap.timeline({
            //     scrollTrigger: {
            //         trigger: ".section--content-10",
            //         start: "top 60%",
            //         end: "bottom 50%",
            //         scrub: true,
            //         onEnter: (self) => {
            //             if (player5.play() !== null) {
            //                 player5.play();
            //             }
            //         },
            //         onEnterBack: (self) => {
            //             if (player5.play() !== null) {
            //                 player5.play();
            //             }
            //         },
            //         onLeave: (self) => {
            //             if (player5.play() !== null) {
            //                 player5.pause();
            //             }
            //         },
            //         onLeaveBack: (self) => {
            //             if (player5.play() !== null) {
            //                 player5.pause();
            //             }
            //         },
            //     },
            // });
            let stDesktop = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--svg .svg-desktop",
                    // scroller: ".smooth-scroll",
                    scrub: true,
                    start: "top 70%",
                    end: "bottom bottom",
                    onUpdate: (self) => {
                        calculateDraw(self.progress);
                    },
                },
            });
        }
    );
    if (typeof stDesktop !== "undefined") {
        stDesktop.scrollTrigger.enable();
    }
    if (typeof stMobile !== "undefined") {
        stMobile.scrollTrigger.disable();
    }
}
function renderMobile() {
    inlineSVG.init(
        {
            svgSelector: ".svg-mobile", // the class attached to all images that should be inlined
            initClass: "js-inlinesvg", // class added to <html>
        },
        function () {
            function calculateDrawMobile(progress) {
                let index = SCROLL_MAP_MOBILE.findIndex(
                    ({ scroll }) => Math.min(1, Math.max(0, progress)) < scroll
                );
                let fromBucket = SCROLL_MAP_MOBILE[index - 1];
                let toBucket = SCROLL_MAP_MOBILE[index];
                let relativeScrollInBucket = inverseLerp(
                    fromBucket.scroll,
                    toBucket.scroll,
                    progress
                );

                let size = lerp(
                    fromBucket.size,
                    toBucket.size,
                    relativeScrollInBucket
                );
                let offset = lerp(
                    fromBucket.offset,
                    toBucket.offset,
                    relativeScrollInBucket
                );

                gsap.to(
                    "#svg-front-mobile",
                    0,
                    { strokeDashoffset: -offset },
                    0
                );
                gsap.to(
                    "#svg-front-mobile",
                    0,
                    { strokeDasharray: `${size}, 100000` },
                    0
                );
                gsap.to(
                    "#svg-back-mobile",
                    0,
                    { strokeDasharray: `${offset}, 100000` },
                    0
                );
                gsap.to(
                    "#svg-dot-mobile",
                    0,
                    { strokeDashoffset: -size - offset },
                    0
                );
            }

            let pathLengthMobile = document
                .querySelector("#svg-front-mobile")
                .getTotalLength();

            const SCROLL_MAP_MOBILE = [
                { scroll: 0, size: 0, offset: 0, width: 3 },
                { scroll: 0.02, size: 40, offset: 40, width: 3 },
                { scroll: 0.05, size: 6500, offset: 100, width: 3 },

                { scroll: 0.075, size: 40, offset: 6900, width: 3 },

                { scroll: 0.091, size: 6500, offset: 6950, width: 3 },

                { scroll: 0.108, size: 100, offset: 13450, width: 3 },
                { scroll: 0.135, size: 100, offset: 14000, width: 3 },
                { scroll: 0.18, size: 100, offset: 14900, width: 3 },
                { scroll: 0.24, size: 100, offset: 15500, width: 3 },
                { scroll: 0.29, size: 4200, offset: 16000, width: 3 },
                // { scroll: 0.29, size: 100, offset: 19800, width: 3 },
                { scroll: 0.35, size: 100, offset: 20500, width: 3 },
                { scroll: 0.38, size: 100, offset: 21500, width: 3 },
                { scroll: 0.44, size: 100, offset: 22000, width: 3 },
                { scroll: 0.445, size: 100, offset: 22100, width: 3 },
                { scroll: 0.47, size: 10700, offset: 22300, width: 3 },
                { scroll: 0.54, size: 100, offset: 33100, width: 3 },
                { scroll: 0.57, size: 100, offset: 33900, width: 3 },
                { scroll: 0.588, size: 100, offset: 34500, width: 3 },

                { scroll: 0.62, size: 10000, offset: 35000, width: 3 },
                // { scroll: 0.624, size: 100, offset: 45300, width: 3 },
                { scroll: 0.69, size: 100, offset: 46000, width: 3 },
                { scroll: 0.72, size: 100, offset: 46300, width: 3 },
                { scroll: 0.77, size: 6230, offset: 46500, width: 3 },
                { scroll: 0.78, size: 100, offset: 52730, width: 3 },
                { scroll: 0.835, size: 100, offset: 53300, width: 3 },
                { scroll: 0.87, size: 100, offset: 54000, width: 3 },
                { scroll: 0.91, size: 6300, offset: 54500, width: 3 },
                { scroll: 0.92, size: 100, offset: 60800, width: 3 },
                {
                    scroll: 0.955,
                    size: 8000,
                    offset: pathLengthMobile - 8000,
                    width: 3,
                },

                // // End
                {
                    scroll: 1 + Number.EPSILON,
                    size: 10,
                    offset: pathLengthMobile - 10,
                    width: 3,
                },
            ];

            gsap.set("#svg-front-mobile", { strokeDasharray: `0, 100000` });
            gsap.set("#svg-back-mobile", { strokeDasharray: `0, 100000` });
            gsap.set("#svg-dot-mobile", {
                strokeDashoffset: -pathLengthMobile,
            });

            gsap.set(
                [
                    "#illustration-1-1",
                    "#illustration-1-2",
                    "#illustration-1-3",
                    "#illustration-1-4",
                    "#illustration-1-5",
                    "#illustration-1-6",
                ],
                { transformOrigin: "center center" }
            );
            var tlIllustration1 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-1",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom 70%",
                        scrub: true,
                    },
                })
                .from("#illustration-1-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-1-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-3", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-4", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-5", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-1-6", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                [
                    "#illustration-2-1",
                    "#illustration-2-2",
                    "#illustration-2-3",
                    "#illustration-2-4",
                ],
                { transformOrigin: "center center" }
            );
            var tlIllustration2 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-2",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-2-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-2-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-2-3", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-2-4", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                [
                    "#illustration-3-1",
                    "#illustration-3-2",
                    "#illustration-3-3",
                    "#illustration-3-4",
                    "#illustration-3-5",
                    "#illustration-3-6",
                    "#illustration-3-7",
                ],
                { transformOrigin: "center center" }
            );
            var tlIllustration3 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-3",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-3-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-3-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-3", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-4", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-5", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-6", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-3-7", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-4-1", "#illustration-4-2", "#illustration-4-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration4 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-4",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-4-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-4-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-4-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-5-1", "#illustration-5-2", "#illustration-5-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration5 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-5",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-5-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-5-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-5-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-6-1", "#illustration-6-2", "#illustration-6-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration6 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-6",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-6-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-6-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-6-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-7-1", "#illustration-7-2", "#illustration-7-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration7 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-7",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-7-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-7-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-7-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            gsap.set(
                ["#illustration-8-1", "#illustration-8-2", "#illustration-8-3"],
                {
                    transformOrigin: "center center",
                }
            );
            var tlIllustration8 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".section--illustration-8",
                        // scroller: ".smooth-scroll",
                        start: "top 50%",
                        end: "bottom bottom",
                        scrub: true,
                    },
                })
                .from("#illustration-8-1", { scale: 0, autoAlpha: 0 })
                .from("#illustration-8-2", { scale: 0, autoAlpha: 0 }, "+=0.1")
                .from("#illustration-8-3", { scale: 0, autoAlpha: 0 }, "+=0.1");

            var tlVideo1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-3",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        // playerHero.stop();
                        player1Mobile.play();
                    },
                    onEnterBack: (self) => {
                        player2Mobile.pause();
                        player1Mobile.play();
                    },
                    onLeave: (self) => {
                        player1Mobile.pause();
                    },
                    onLeaveBack: (self) => {
                        player1Mobile.pause();
                    },
                },
            });
            var tlVideo2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-5",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        player1Mobile.pause();
                        player2Mobile.play();
                    },
                    onEnterBack: (self) => {
                        player3Mobile.pause();
                        player2Mobile.play();
                    },
                    onLeave: (self) => {
                        player2Mobile.pause();
                    },
                    onLeaveBack: (self) => {
                        player2Mobile.play();
                    },
                },
            });
            var tlVideo3 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-6",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        player2Mobile.pause();
                        player3Mobile.play();
                    },
                    onEnterBack: (self) => {
                        player4Mobile.pause();
                        player3Mobile.play();
                    },
                    onLeave: (self) => {
                        player3Mobile.pause();
                    },
                    onLeaveBack: (self) => {
                        player3Mobile.pause();
                    },
                },
            });
            var tlVideo4 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--content-7",
                    start: "top 60%",
                    end: "bottom 50%",
                    scrub: true,
                    onEnter: (self) => {
                        player3Mobile.pause();
                        player4Mobile.play();
                    },
                    onEnterBack: (self) => {
                        player5Mobile.pause();
                        player4Mobile.play();
                    },
                    onLeave: (self) => {
                        player4Mobile.pause();
                    },
                    onLeaveBack: (self) => {
                        player4Mobile.pause();
                    },
                },
            });
            // var tlVideo5 = gsap.timeline({
            //     scrollTrigger: {
            //         trigger: ".section--content-10",
            //         start: "top 60%",
            //         end: "bottom 50%",
            //         scrub: true,
            //         onEnter: (self) => {
            //             player4Mobile.pause();
            //             player5Mobile.play();
            //         },
            //         onEnterBack: (self) => {
            //             player4Mobile.pause();

            //             player5Mobile.play();
            //         },
            //         onLeave: (self) => {
            //             // player5.pause();
            //         },
            //         onLeaveBack: (self) => {
            //             player5Mobile.pause();
            //         },
            //     },
            // });

            let stMobile = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section--svg .svg-mobile",
                    // scroller: ".smooth-scroll",
                    scrub: true,
                    start: "top 70%",
                    end: "bottom bottom",
                    // markers: true,
                    onUpdate: (self) => {
                        calculateDrawMobile(self.progress);
                    },
                },
            });
        }
    );
    if (typeof stDesktop !== "undefined") {
        stDesktop.scrollTrigger.disable();
    }
    if (typeof stMobile !== "undefined") {
        stMobile.scrollTrigger.enable();
    }
}
});